import { render, staticRenderFns } from "./carrierSelect.vue?vue&type=template&id=9c510dda&scoped=true&"
import script from "./carrierSelect.vue?vue&type=script&lang=ts&"
export * from "./carrierSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c510dda",
  null
  
)

export default component.exports